import { groupBy } from '@skylab-shared/utils';

export type GridGroupItem<TEntity> = {
    groupKey: keyof TEntity;
    groupValue: unknown;
    expanded: boolean;
    label: string;
};

export class GridGroupUtils {
    public static groupBy<TItem>(collection: TItem[], propertyName: keyof TItem, titleTranslationFunction: (key: any) => string, sortGroup?: (a: TItem, b: TItem) => number): (TItem | GridGroupItem<TItem>)[] {
        const groupMap = groupBy(collection, entity => entity[propertyName]);
        const grouped = Array.from(groupMap.keys()).reduce<(TItem | GridGroupItem<TItem>)[]>((prev, curr) => {
            const rawValues = groupMap.get(curr);
            if (!rawValues) return prev;
            const values = sortGroup ? [...rawValues].sort(sortGroup) : rawValues;
            const firstValue = values[0];
            const groupItem: GridGroupItem<TItem> = {
                groupKey: propertyName,
                groupValue: firstValue ? firstValue[propertyName] : undefined,
                label: titleTranslationFunction(curr),
                expanded: true
            };
            return [...prev, groupItem, ...values];
        }, []);

        return grouped;
    }
}
